// chambreService.js
import { chambreAPI } from './restaurantAPI';

const chambreService = {
  // Get all rooms
  async getAll(params = {}) {
    try {
      const response = await chambreAPI.getAll(params);
      console.log('Chambre API Response:', response);
      return response.data;
    } catch (error) {
      console.error('Error in chambreService.getAll:', error);
      throw error;
    }
  },

  // Get available rooms
  async getAvailable(params = {}) {
    try {
      const response = await chambreAPI.getAvailable(params);
      return response.data;
    } catch (error) {
      console.error('Error in chambreService.getAvailable:', error);
      throw error;
    }
  },

  // Get room details
  async get(id) {
    try {
      const response = await chambreAPI.getById(id);
      return response.data;
    } catch (error) {
      console.error('Error in chambreService.get:', error);
      throw error;
    }
  },

  // Update room status
  async setStatus(id, status) {
    try {
      const response = await chambreAPI.setStatus(id, status);
      return response.data;
    } catch (error) {
      console.error('Error in chambreService.setStatus:', error);
      throw error;
    }
  },

  // Get rooms by status
  async getByStatus(status) {
    try {
      const response = await chambreAPI.getAll({ statut: status });
      return response.data;
    } catch (error) {
      console.error('Error in chambreService.getByStatus:', error);
      throw error;
    }
  }
};

export default chambreService;